import type { AmbiguousLink } from '@/types/ambiguousLinks';
import { Button } from '@music-vine/cadence/ui';
import Link from 'next/link';
import { useRouter } from 'next/router';
import SoundEffects from '@/components/Icons/Sidebar/SoundEffects';
import { logEvent } from '@/pages/api/v1/utils';
export interface HeaderAmbiguousLinkProps {
  data: AmbiguousLink;
}

/**
 * Header ambiguous link component
 */
const HeaderAmbiguousLink = ({
  data: {
    name,
    url,
    type
  }
}: HeaderAmbiguousLinkProps) => {
  const displayType = type === 'sfx' ? 'sound effects' : type;
  const router = useRouter();
  return <Button asChild className="w-fit font-semibold" fontSize={{
    default: 'sm',
    '2xl': 'sm'
  }} onClick={() => {
    void logEvent({
      event_type: 'click',
      asPath: router.asPath,
      metadata: {
        type: 'ambiguous_link',
        text: `Looking for ${name} ${displayType}?`,
        next_path: url
      }
    });
  }} size="sm" variant="light" data-sentry-element="Button" data-sentry-component="HeaderAmbiguousLink" data-sentry-source-file="ambiguous-link.tsx">
      <Link href={url} data-sentry-element="Link" data-sentry-source-file="ambiguous-link.tsx">
        <SoundEffects className="h-4 w-4" data-sentry-element="SoundEffects" data-sentry-source-file="ambiguous-link.tsx" /> Looking for {name} {displayType}?
      </Link>
    </Button>;
};
HeaderAmbiguousLink.displayName = 'HeaderAmbiguousLink';
export { HeaderAmbiguousLink };